import React, { forwardRef, useEffect, useState } from "react";
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import { AddBox, ArrowDownward } from "@material-ui/icons";
import { Spinner } from "reactstrap";
import MaterialTable from "material-table";
import {
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import DurationDropdown from "components/dropdown/durationDropdown";
import MonthsDropdown from "components/dropdown/monthsDropdown";
import RegionsDropdown from "components/dropdown/regionsDropdown";
import DatePicker from "components/dropdown/datePicker";
import WeekPicker from "components/dropdown/weekPicker/index";
import ReportChat from "./reportChat";
import axiosService from "service/axios-service";
import YearsDropdown from "components/dropdown/yearsDropdown";
import { Breadcrumbs } from "@mui/material";
import { getCurrentYear } from "utils/date";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const SystemUsageReport = ({ t }) => {
  const [loader, setLoader] = useState(false);
  const [duration, setDuration] = useState("");
  const [month, setMonth] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [region, setRegion] = useState("");
  const [details, setDetails] = useState([]);
  const [data, setData] = useState(null);
  const [regionList, setRegionList] = useState([]);
  const [selectedYear, setYear] = useState(getCurrentYear());
  const [nav, setNav] = useState([""]);

  useEffect(() => {
    axiosService
      .get("/sales/incentive/admin/fetch_region")
      .then(({ data }) => {
        console.log("fetch_region", data);
        const region = data?.map((item) => ({
          value: item,
          label: item,
        }));
        setRegionList(region);
      })
      .catch(() => {});
  }, []);

  const formatDate = (date, time) => {
    const d = new Date(date);
    let day = d.getDate();
    let month = d.getMonth() + 1;
    const year = selectedYear;

    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }

    let hours = d.getHours();
    let minutes = d.getMinutes();
    let seconds = d.getSeconds();

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return time
      ? `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
      : `${day}-${month}-${year}`;
  };

  const handleSubmit = async () => {
    setLoader(true);
    axiosService
      .get(
        `/sales/incentive/admin/login_chart?region=${
          region == "all" ? "" : region
        }&from=${formatDate(startDate)}&to=${formatDate(endDate)}`
      )
      .then((res) => {
        setLoader(false);
        console.log("login_chart?region", res);
        setData(res?.data);
      })
      .catch((err) => {
        setLoader(false);
        console.log("err", { err });
      });
  };

  const getDetails = (login) => {
    axiosService
      .get(
        `/sales/incentive/admin/login_details?login=${login}&region=${
          region == "all" ? "" : region
        }&from=${formatDate(startDate)}&to=${formatDate(endDate)}`
      )
      .then((res) => {
        console.log("login_details?login", res);
        setDetails(res?.data?.users ?? []);
      })
      .catch((err) => {});
  };

  const onJump = (index) => {
    const newNav = index ? [...nav].slice(0, index) : [""];
    setNav(newNav);
  };

  return (
    <>
      <Breadcrumb title={t("system usages report")} />
      <div className="app-wrapper" style={{}}>
        <div className="animated slideInUpTiny animation-duration-3">
          <div className="row dashboardDetails">
            <div className={"col-md-12 col-sm-12 col-xs-12"}>
              <Paper
                style={{ overflow: "hidden", marginTop: 10, padding: 25 }}
                elevation={5}
              >
                <div className="row" style={{ display: "flex" }}>
                  <div className="col-md-3 col-sm-12">
                    <div className="row">
                      <DurationDropdown
                        value={duration}
                        onChange={(e) => {
                          setDuration(e.target.value);
                          setRegion("");
                          setStartDate("");
                          setEndDate("");
                          setMonth("");
                        }}
                      />
                    </div>
                  </div>
                  {duration && (
                    <div className="col-md-3 col-sm-12">
                      <div className="row">
                        <YearsDropdown
                          value={selectedYear}
                          onChange={(e) => {
                            setYear(e.target.value);
                            setStartDate(`${e.target.value}-01-01`);
                            setEndDate(`${e.target.value}-01-01`);
                          }}
                          className="col-md-12 col-sm-12"
                        />
                      </div>
                    </div>
                  )}
                  {duration == "Daily" && (
                    <div className="col-md-3 col-sm-12">
                      <div className="row">
                        <DatePicker
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(e.target.value);
                            setEndDate(e.target.value);
                          }}
                          className="col-md-12 col-sm-12"
                        />
                      </div>
                    </div>
                  )}

                  {duration == "Weekly" && (
                    <div className="col-md-3 col-sm-12">
                      <div className="row">
                        <WeekPicker
                          onChange={(startDate, endDate) => {
                            setStartDate(startDate);
                            setEndDate(endDate);
                          }}
                          className="col-md-12 col-sm-12"
                        />
                      </div>
                    </div>
                  )}
                  {duration == "Monthly" && (
                    <div className="col-md-3 col-sm-12">
                      <div className="row">
                        <MonthsDropdown
                          value={month}
                          onChange={(e) => {
                            const selectedMonth = e.target.value;
                            const year = new Date().getFullYear();
                            const startDate = new Date(
                              year,
                              selectedMonth - 1,
                              1
                            );
                            const endDate = new Date(year, selectedMonth, 0);
                            setStartDate(startDate);
                            setEndDate(endDate);
                            setMonth(e.target.value);
                          }}
                          className="col-md-12 col-sm-12"
                        />
                      </div>
                    </div>
                  )}

                  {startDate != "" || month != "" ? (
                    <div className="col-md-3 col-sm-12">
                      <div className="row">
                        <RegionsDropdown
                          regionList={regionList}
                          value={region}
                          onChange={(e) => setRegion(e.target.value)}
                          className="col-md-12 col-sm-12"
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-3 col-sm-12 d-flex align-items-end">
                    <div className="row pt-3">
                      <div className="col-md-4 col-sm-6">
                        <Button
                          disabled={
                            !(
                              duration != "" &&
                              region != "" &&
                              (startDate != "" || month != "")
                            )
                          }
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          style={{ marginRight: 10, height: 36, width: 80 }}
                        >
                          {loader ? <Spinner size="sm" /> : t("search")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Paper>
            </div>
          </div>
        </div>

        {data ? (
          <div className="animated slideInUpTiny animation-duration-3">
            <>
              <Paper
                style={{
                  height: "auto",
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    Employee
                  </Typography>
                </div>
                {nav.length > 1 ? (
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    style={{ marginTop: 16, alignSelf: "flex-start" }}
                  >
                    {nav.map((n, index) => {
                      return (
                        <Button
                          disabled={index + 1 === nav.length}
                          color="primary"
                          size="small"
                          onClick={() => onJump(index)}
                        >
                          {n || "Types"}
                        </Button>
                      );
                    })}
                  </Breadcrumbs>
                ) : null}
                {nav?.length == 1 && (
                  <ReportChat
                    data={data}
                    onClick={(login) => {
                      console.log("Clicked", login);
                      getDetails(login);
                      setNav([
                        ...nav,
                        login ? "Logged in Users" : "Not Logged in Users",
                      ]);
                    }}
                  />
                )}
                {nav?.length == 2 && (
                  <MaterialTable
                    style={{ width: "100%", marginTop: 10 }}
                    icons={tableIcons}
                    columns={[
                      { title: t("Employee name"), field: "staff_name" },
                      { title: t("Staff I'd"), field: "userId" },
                      { title: t("Mobile"), field: "staff_mobile_no" },
                      { title: t("Logged Count"), field: "loginTime" },
                      { title: t("Region"), field: "staff_region" },
                      { title: t("Supervisor Name"), field: "supervisor_name" },
                    ]}
                    data={details.map((item) => {
                      return {
                        staff_name: item.staff_name,
                        userId: item.userId,
                        staff_mobile_no: item.staff_mobile_no,
                        loginTime:
                          nav[1] == "Logged in Users"
                            ? formatDate(item.loginTime, true)
                            : "",
                        staff_region: item.staff_region,
                        supervisor_name: item.supervisor_name,
                      };
                    })}
                    title={
                      <h2>
                        {/* <IntlMessages tagName="strong" id="Companies" /> */}
                      </h2>
                    }
                    options={{
                      search: false,
                    }}
                  />
                )}
              </Paper>
            </>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default translate(SystemUsageReport);
